var _rect, _path, _path2, _line, _line2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _rect2, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _rect3, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polyline, _path29, _path30, _path31, _path32, _line64, _path33, _path34, _path35, _path36;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackSvg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Background_Simple",
    "data-name": "Background Simple",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471,238.3c-4.94,41.8-24,90.4-62.14,112.73-57.6,33.74-52.78,85.63-165.2,108.2a230.54,230.54,0,0,1-49.84,4.7,191.28,191.28,0,0,1-24.47-2c-71.44-10.44-119.53-60.1-137.17-120C9,263,55.33,211.42,86.06,180.32s53.22-128,163.56-151a224.36,224.36,0,0,1,51.23-4.86c39.26,1,82.08,13.85,111.71,40.76q3.35,3,6.5,6.27C460.24,113.72,477.74,181.31,471,238.3Z",
    fill: "#92e3a9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M471,238.3c-4.94,41.8-24,90.4-62.14,112.73-57.6,33.74-52.78,85.63-165.2,108.2a230.54,230.54,0,0,1-49.84,4.7,191.28,191.28,0,0,1-24.47-2c-71.44-10.44-119.53-60.1-137.17-120C9,263,55.33,211.42,86.06,180.32s53.22-128,163.56-151a224.36,224.36,0,0,1,51.23-4.86c39.26,1,82.08,13.85,111.71,40.76q3.35,3,6.5,6.27C460.24,113.72,477.74,181.31,471,238.3Z",
    fill: "#f1ffff",
    opacity: 0.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 463.78,
    y1: 282.93,
    x2: 478.97,
    y2: 282.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.6,
    y1: 282.93,
    x2: 456.98,
    y2: 282.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440.46,165.83V158L433,156.93a27.14,27.14,0,0,0-4.31-10.48l4.56-6.09-5.54-5.53-6.05,4.54A27.34,27.34,0,0,0,411.16,135l-1.07-7.52h-7.83L401.19,135a27.18,27.18,0,0,0-10.49,4.31l-6.08-4.56-5.54,5.54,4.55,6.05a27,27,0,0,0-4.37,10.47l-7.53,1.07v7.83l7.5,1.07a27,27,0,0,0,4.3,10.49L379,183.32l5.54,5.54,6.06-4.54A27.23,27.23,0,0,0,401,188.69l1.08,7.52h7.82l1.08-7.5a27.07,27.07,0,0,0,10.49-4.3l6.08,4.56,5.53-5.54-4.54-6.06a27.08,27.08,0,0,0,4.37-10.46Zm-34.36,15a19,19,0,1,1,19-19A19,19,0,0,1,406.1,180.82Z",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M462.16,212.54v-5.6l-5.36-.76a19.35,19.35,0,0,0-3.08-7.5l3.26-4.35-4-4-4.33,3.25a19.5,19.5,0,0,0-7.48-3.13l-.77-5.38h-5.6l-.77,5.36a19.57,19.57,0,0,0-7.5,3.08l-4.35-3.26-4,4,3.24,4.33a19.53,19.53,0,0,0-3.12,7.49l-5.38.76v5.6l5.36.77a19.35,19.35,0,0,0,3.08,7.5l-3.26,4.35,4,4,4.33-3.25a19.33,19.33,0,0,0,7.48,3.12l.77,5.39h5.6l.77-5.37a19.4,19.4,0,0,0,7.5-3.07l4.35,3.26,3.95-4-3.25-4.34a19.28,19.28,0,0,0,3.13-7.48Zm-24.58,10.72a13.57,13.57,0,1,1,13.58-13.57A13.58,13.58,0,0,1,437.58,223.26Z",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52,208.69v7.14l6.84,1a24.69,24.69,0,0,0,3.93,9.57l-4.16,5.55,5.05,5,5.53-4.14a24.81,24.81,0,0,0,9.54,4l1,6.86h7.14l1-6.84a24.6,24.6,0,0,0,9.57-3.93l5.55,4.16,5-5.05-4.15-5.53a24.81,24.81,0,0,0,4-9.54l6.87-1v-7.15l-6.84-1a24.91,24.91,0,0,0-3.93-9.57l4.16-5.55-5-5-5.53,4.15a24.85,24.85,0,0,0-9.55-4l-1-6.87H94.38l-1,6.84a24.85,24.85,0,0,0-9.57,3.93l-5.55-4.16-5,5,4.14,5.53a24.92,24.92,0,0,0-4,9.55ZM97.88,195a17.32,17.32,0,1,1-17.32,17.31A17.32,17.32,0,0,1,97.88,195Z",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.85,169.81v4.36l4.17.59a15.09,15.09,0,0,0,2.4,5.84L52.88,184,56,187.07l3.37-2.53A15.09,15.09,0,0,0,65.16,187l.59,4.19h4.36l.6-4.17a15.22,15.22,0,0,0,5.84-2.4l3.38,2.54L83,184.05l-2.53-3.38a15.07,15.07,0,0,0,2.44-5.82l4.18-.6v-4.36l-4.17-.59a15.23,15.23,0,0,0-2.39-5.84l2.53-3.39L80,157l-3.37,2.53a15.11,15.11,0,0,0-5.82-2.43l-.6-4.19H65.84l-.6,4.17a15.22,15.22,0,0,0-5.84,2.4L56,156.93,52.94,160l2.53,3.38A15,15,0,0,0,53,169.21ZM68,161.47A10.56,10.56,0,1,1,57.41,172,10.56,10.56,0,0,1,68,161.47Z",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.7,90.3v6l5.73.82a20.74,20.74,0,0,0,3.29,8l-3.49,4.65,4.23,4.23,4.64-3.47a20.78,20.78,0,0,0,8,3.34l.82,5.75h6l.82-5.73a20.9,20.9,0,0,0,8-3.29l4.64,3.48,4.23-4.23-3.47-4.63a20.67,20.67,0,0,0,3.34-8l5.76-.82v-6l-5.74-.82a20.68,20.68,0,0,0-3.29-8l3.49-4.65-4.23-4.23-4.63,3.47a20.82,20.82,0,0,0-8-3.34L246,67.08h-6l-.82,5.73a20.63,20.63,0,0,0-8,3.29l-4.65-3.48-4.23,4.23,3.47,4.63a20.82,20.82,0,0,0-3.34,8ZM243,78.84a14.51,14.51,0,1,1-14.51,14.51A14.51,14.51,0,0,1,243,78.84Z",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.91,90H390a8,8,0,0,1,8,8V289.41a0,0,0,0,1,0,0h-291a0,0,0,0,1,0,0V98A8,8,0,0,1,114.91,90Z",
    fill: "#000102",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "441.63 377.57 63.28 377.57 106.94 289.41 397.98 289.41 441.63 377.57",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 124.56,
    y: 105.79,
    width: 255.78,
    height: 167.84,
    fill: "#45e1c2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "240.31 317.32 240.82 306.58 225.44 306.58 224.42 317.32 240.31 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.1 317.32 271.57 306.58 256.2 306.58 256.21 317.32 272.1 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.87 328.8 371.31 328.8 367.45 317.32 351.56 317.32 354.87 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "224.42 317.32 225.44 306.58 210.06 306.58 208.53 317.32 224.42 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "192.64 317.32 194.69 306.58 179.31 306.58 176.75 317.32 192.64 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "335.67 317.32 333.09 306.58 317.71 306.58 319.78 317.32 335.67 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.56 317.32 348.46 306.58 333.09 306.58 335.67 317.32 351.56 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "176.75 317.32 179.31 306.58 163.93 306.58 160.85 317.32 176.75 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "287.99 317.32 286.95 306.58 271.57 306.58 272.1 317.32 287.99 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.45 317.32 363.84 306.58 348.46 306.58 351.56 317.32 367.45 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.78 317.32 317.71 306.58 302.33 306.58 303.88 317.32 319.78 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.88 317.32 302.33 306.58 286.95 306.58 287.99 317.32 303.88 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.21 317.32 256.2 306.58 240.82 306.58 240.31 317.32 256.21 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "144.96 317.32 129.07 317.32 124.68 328.8 141.12 328.8 144.96 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "148.55 306.58 133.17 306.58 129.07 317.32 144.96 317.32 148.55 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.85 317.32 163.93 306.58 148.55 306.58 144.96 317.32 160.85 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.98 341.11 114.93 354.34 132.59 354.34 137.01 341.11 119.98 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 328.8 124.68 328.8 119.98 341.11 137.01 341.11 141.12 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.01 341.11 132.59 354.34 150.25 354.34 154.04 341.11 137.01 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "208.53 317.32 210.06 306.58 194.69 306.58 192.64 317.32 208.53 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.89 328.8 208.53 317.32 192.64 317.32 190.45 328.8 206.89 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.45 328.8 192.64 317.32 176.75 317.32 174.01 328.8 190.45 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "223.33 328.8 224.42 317.32 208.53 317.32 206.89 328.8 223.33 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.85 317.32 144.96 317.32 141.12 328.8 157.57 328.8 160.85 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.42 341.11 375.45 341.11 371.31 328.8 354.87 328.8 358.42 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.01 328.8 176.75 317.32 160.85 317.32 157.57 328.8 174.01 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 328.8 137.01 341.11 154.04 341.11 157.57 328.8 141.12 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "321.99 328.8 319.78 317.32 303.88 317.32 305.54 328.8 321.99 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "305.54 328.8 303.88 317.32 287.99 317.32 289.1 328.8 305.54 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.87 328.8 351.56 317.32 335.67 317.32 338.43 328.8 354.87 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.22 328.8 256.21 317.32 240.31 317.32 239.78 328.8 256.22 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "289.1 328.8 287.99 317.32 272.1 317.32 272.66 328.8 289.1 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.66 328.8 272.1 317.32 256.21 317.32 256.22 328.8 272.66 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.78 328.8 240.31 317.32 224.42 317.32 223.33 328.8 239.78 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "289.1 328.8 290.29 341.11 307.32 341.11 305.54 328.8 289.1 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "305.54 328.8 307.32 341.11 324.36 341.11 321.99 328.8 305.54 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "157.57 328.8 154.04 341.11 171.07 341.11 174.01 328.8 157.57 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "321.99 328.8 324.36 341.11 341.39 341.11 338.43 328.8 321.99 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.22 328.8 256.23 341.11 273.26 341.11 272.66 328.8 256.22 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "338.43 328.8 341.39 341.11 358.42 341.11 354.87 328.8 338.43 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.66 328.8 273.26 341.11 290.29 341.11 289.1 328.8 272.66 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.45 328.8 188.1 341.11 205.13 341.11 206.89 328.8 190.45 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.01 328.8 171.07 341.11 188.1 341.11 190.45 328.8 174.01 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.78 328.8 239.2 341.11 256.23 341.11 256.22 328.8 239.78 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "223.33 328.8 222.17 341.11 239.2 341.11 239.78 328.8 223.33 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.89 328.8 205.13 341.11 222.17 341.11 223.33 328.8 206.89 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "338.43 328.8 335.67 317.32 319.78 317.32 321.99 328.8 338.43 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "148.55 306.58 152.23 295.58 137.38 295.58 133.17 306.58 148.55 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "133.17 306.58 118.98 306.58 114.4 317.32 129.07 317.32 133.17 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.38 295.58 123.67 295.58 118.98 306.58 133.17 306.58 137.38 295.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.07 317.32 114.4 317.32 109.5 328.8 124.68 328.8 129.07 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.68 328.8 109.5 328.8 104.26 341.11 119.98 341.11 124.68 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.98 341.11 104.26 341.11 98.62 354.34 114.93 354.34 119.98 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    points: "383.35 317.32 387.75 328.8 402.3 328.8 397.4 317.32 383.35 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.48 341.11 407.55 341.11 402.3 328.8 387.75 328.8 392.48 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.56 354.34 413.18 354.34 407.55 341.11 392.48 341.11 397.56 354.34",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.57 306.58 271.04 295.58 256.19 295.58 256.2 306.58 271.57 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    points: "383.35 317.32 397.4 317.32 392.82 306.58 379.22 306.58 383.35 317.32",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    points: "375.45 341.11 392.48 341.11 387.75 328.8 371.31 328.8 375.45 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.93 306.58 167.08 295.58 152.23 295.58 148.55 306.58 163.93 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.84 306.58 367.45 317.32 383.35 317.32 379.22 306.58 363.84 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.82 306.58 388.14 295.58 375 295.58 379.22 306.58 392.82 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    points: "379.22 306.58 375 295.58 360.15 295.58 363.84 306.58 379.22 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.36 341.11 326.9 354.34 344.56 354.34 341.39 341.11 324.36 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    points: "379.89 354.34 397.56 354.34 392.48 341.11 375.45 341.11 379.89 354.34",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.84 306.58 360.15 295.58 345.3 295.58 348.46 306.58 363.84 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.42 341.11 362.23 354.34 379.89 354.34 375.45 341.11 358.42 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    points: "341.39 341.11 344.56 354.34 362.23 354.34 358.42 341.11 341.39 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    points: "371.31 328.8 387.75 328.8 383.35 317.32 367.45 317.32 371.31 328.8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    points: "225.44 306.58 226.48 295.58 211.63 295.58 210.06 306.58 225.44 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.46 306.58 345.3 295.58 330.45 295.58 333.09 306.58 348.46 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    points: "210.06 306.58 211.63 295.58 196.78 295.58 194.69 306.58 210.06 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.2 306.58 256.19 295.58 241.34 295.58 240.82 306.58 256.2 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    points: "194.69 306.58 196.78 295.58 181.93 295.58 179.31 306.58 194.69 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    points: "179.31 306.58 181.93 295.58 167.08 295.58 163.93 306.58 179.31 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    points: "240.82 306.58 241.34 295.58 226.48 295.58 225.44 306.58 240.82 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    points: "333.09 306.58 330.45 295.58 315.59 295.58 317.71 306.58 333.09 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.71 306.58 315.59 295.58 300.74 295.58 302.33 306.58 317.71 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    points: "286.95 306.58 285.89 295.58 271.04 295.58 271.57 306.58 286.95 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.36 341.11 307.32 341.11 290.29 341.11 273.26 341.11 256.23 341.11 239.2 341.11 222.17 341.11 205.13 341.11 188.1 341.11 171.07 341.11 154.04 341.11 150.25 354.34 167.92 354.34 185.58 354.34 203.25 354.34 220.91 354.34 238.58 354.34 256.24 354.34 273.91 354.34 291.57 354.34 309.23 354.34 326.9 354.34 324.36 341.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.33 306.58 300.74 295.58 285.89 295.58 286.95 306.58 302.33 306.58",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.28,
    y: 377.57,
    width: 378.52,
    height: 5.37,
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 141.05,
    y1: 119.02,
    x2: 157.55,
    y2: 119.02,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 141.05,
    y1: 127.49,
    x2: 203,
    y2: 127.49,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 236.88,
    y1: 127.49,
    x2: 298.83,
    y2: 127.49,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 207.02,
    y1: 127.49,
    x2: 231.53,
    y2: 127.49,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 141.05,
    y1: 135.96,
    x2: 176.71,
    y2: 135.96,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 181.17,
    y1: 135.96,
    x2: 216.82,
    y2: 135.96,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 221.28,
    y1: 135.96,
    x2: 256.93,
    y2: 135.96,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 261.39,
    y1: 135.96,
    x2: 276.54,
    y2: 135.96,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 119.02,
    x2: 178.49,
    y2: 119.02,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 260.05,
    y1: 119.02,
    x2: 276.54,
    y2: 119.02,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 238.21,
    y1: 119.02,
    x2: 254.7,
    y2: 119.02,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 182.95,
    y1: 119.02,
    x2: 231.08,
    y2: 119.02,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 141.05,
    y1: 170.72,
    x2: 157.55,
    y2: 170.72,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 141.05,
    y1: 179.19,
    x2: 203,
    y2: 179.19,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 236.88,
    y1: 179.19,
    x2: 298.83,
    y2: 179.19,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 207.02,
    y1: 179.19,
    x2: 231.53,
    y2: 179.19,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 141.05,
    y1: 187.66,
    x2: 176.71,
    y2: 187.66,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 181.17,
    y1: 187.66,
    x2: 216.82,
    y2: 187.66,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 221.28,
    y1: 187.66,
    x2: 256.93,
    y2: 187.66,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 261.39,
    y1: 187.66,
    x2: 276.54,
    y2: 187.66,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 170.72,
    x2: 178.49,
    y2: 170.72,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 260.05,
    y1: 170.72,
    x2: 276.54,
    y2: 170.72,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 238.21,
    y1: 170.72,
    x2: 254.7,
    y2: 170.72,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 182.95,
    y1: 170.72,
    x2: 231.08,
    y2: 170.72,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 141.05,
    y1: 246.93,
    x2: 157.55,
    y2: 246.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 141.05,
    y1: 255.4,
    x2: 203,
    y2: 255.4,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 236.88,
    y1: 255.4,
    x2: 298.83,
    y2: 255.4,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 207.02,
    y1: 255.4,
    x2: 231.53,
    y2: 255.4,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 141.05,
    y1: 263.87,
    x2: 176.71,
    y2: 263.87,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 181.17,
    y1: 263.87,
    x2: 216.82,
    y2: 263.87,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 221.28,
    y1: 263.87,
    x2: 256.93,
    y2: 263.87,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 261.39,
    y1: 263.87,
    x2: 276.54,
    y2: 263.87,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 246.93,
    x2: 178.49,
    y2: 246.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 260.05,
    y1: 246.93,
    x2: 276.54,
    y2: 246.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 238.21,
    y1: 246.93,
    x2: 254.7,
    y2: 246.93,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 182.95,
    y1: 246.93,
    x2: 231.08,
    y2: 246.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 233.76,
    y1: 144.87,
    x2: 250.25,
    y2: 144.87,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 211.92,
    y1: 144.87,
    x2: 228.41,
    y2: 144.87,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 156.65,
    y1: 144.87,
    x2: 204.79,
    y2: 144.87,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 233.76,
    y1: 160.02,
    x2: 250.25,
    y2: 160.02,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 211.92,
    y1: 160.02,
    x2: 228.41,
    y2: 160.02,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 156.65,
    y1: 160.02,
    x2: 204.79,
    y2: 160.02,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 173.14,
    y1: 152.45,
    x2: 156.65,
    y2: 152.45,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 194.98,
    y1: 152.45,
    x2: 178.49,
    y2: 152.45,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 250.25,
    y1: 152.45,
    x2: 202.11,
    y2: 152.45,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 233.76,
    y1: 197.91,
    x2: 250.25,
    y2: 197.91,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 211.92,
    y1: 197.91,
    x2: 228.41,
    y2: 197.91,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 156.65,
    y1: 197.91,
    x2: 204.79,
    y2: 197.91,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 233.76,
    y1: 213.06,
    x2: 250.25,
    y2: 213.06,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 211.92,
    y1: 213.06,
    x2: 228.41,
    y2: 213.06,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 156.65,
    y1: 213.06,
    x2: 204.79,
    y2: 213.06,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 173.14,
    y1: 205.48,
    x2: 156.65,
    y2: 205.48,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 194.98,
    y1: 205.48,
    x2: 178.49,
    y2: 205.48,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 250.25,
    y1: 205.48,
    x2: 202.11,
    y2: 205.48,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 173.14,
    y1: 221.98,
    x2: 156.65,
    y2: 221.98,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 194.98,
    y1: 221.98,
    x2: 178.49,
    y2: 221.98,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 250.25,
    y1: 221.98,
    x2: 202.11,
    y2: 221.98,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 173.14,
    y1: 237.13,
    x2: 156.65,
    y2: 237.13,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 194.98,
    y1: 237.13,
    x2: 178.49,
    y2: 237.13,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 250.25,
    y1: 237.13,
    x2: 202.11,
    y2: 237.13,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 233.76,
    y1: 229.55,
    x2: 250.25,
    y2: 229.55,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 211.92,
    y1: 229.55,
    x2: 228.41,
    y2: 229.55,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 156.65,
    y1: 229.55,
    x2: 204.79,
    y2: 229.55,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 116.08,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 124.62,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 133.17,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 141.71,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 150.25,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 158.8,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 167.34,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 175.88,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 184.43,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 192.97,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 201.51,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 210.06,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 218.6,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 227.14,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 235.69,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 244.23,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 252.77,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 261.32,
    width: 5.27,
    height: 5.2,
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M380,22.66a57.18,57.18,0,0,0-39.52,98.51l-8.14,15.2,20-6.48A57.19,57.19,0,1,0,380,22.66Z",
    fill: "#5ca08d",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M377.31,18.58a57.18,57.18,0,0,0-39.52,98.51l-8.14,15.19,20-6.47A57.19,57.19,0,1,0,377.31,18.58Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M358.16,99.34l-22-15.52V75.59l22-15.67v8.3L342.41,79.67l15.75,11.45Z",
    fill: "#92e3a9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M364.85,102.11,381.6,39.86h7.15l-16.83,62.25Z",
    fill: "#92e3a9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43,99.34V91.12l15.83-11.53L395.43,68.22v-8.3l22.06,15.6v8.22Z",
    fill: "#92e3a9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M360.89,95.93l-22-15.52V72.19l22-15.68v8.3L345.13,76.26l15.76,11.45Z",
    fill: "#0b4860"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M367.57,98.7l16.75-62.24h7.15L374.64,98.7Z",
    fill: "#0b4860"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M398.15,95.93V87.71L414,76.19,398.15,64.81v-8.3l22.06,15.6v8.23Z",
    fill: "#0b4860"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M333.83,383.53l34.63,28.59a49.6,49.6,0,0,0,6.81,11.57c4.77,6.13,60.6,29.28,60.6,29.28l9.53,2.72-104.17-78.3Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M401.28,360.82s-9.29-11.36-13.42-18.58-10-24.09-14.46-34.07-11-13.07-18.92-16.17-11-2.41-11-.34,3.1,5.85,3.1,5.85l-13.42,2.41s-5.51-3.1-8.95-2.07-10,7.57-10,7.57-6.88-2.41-11-1.38-15.48,6.54-20.3,8.95-10,2.75-9.64,4.82,5.17,5.5,9.64,4.82,12-3.45,16.86-3.45,7.22,1,9.63,2.76,12.39,15.83,13.77,17.55,2.75,8.6,2.75,8.6-6.07-2.59-9.85-6-9.2-11.51-15.4-12.19-12.94,4.81-9.5,7.56,6.88,4.47,9.29,7.57,6.19,12.39,12.73,22.37,20.64,16.17,20.64,16.17l29.25,12s7.57-17.89,21.68-22.71S403,366,403,366Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M273.27,317.81s3.36-.86,4.33-1.18a7.94,7.94,0,0,0,2.09-1.29",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M314.22,305.42s15.85,8.87,20.32,11.27c1.84,1,6.2,3,7.54,7.54a19.16,19.16,0,0,0,4.8,8.23",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M333.15,299.92s15.48,12,16.51,12.38,4.82.69,6.54,3.79,3.44,6.54,3.44,6.54",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M346.57,297.51s5.5-1,7.57,3.09,11,14.11,11,14.11",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M297.36,341.89s4.13-2.06,2.06-5.16-6.19-3.09-6.19-3.09",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M400.59,356.35s-18.58,4.81-30.28,17.89-11.7,24.09-10.67,25.81S383,413.81,383,413.81s13.76-26.5,23.4-33S423,372.52,423,372.52s-17.2-11-17.89-12.39S403,355.31,400.59,356.35Z",
    fill: "#45e1c2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M452.89,459.92s-18.93-9.64-23.4-12.05L394.39,429a41.74,41.74,0,0,1-5.85-2.06c-2.06-1-5.16-.69-6.53-7.92s2.06-21.68,17.55-36.13,25.11-13.76,25.11-13.76,6.54-.69,8.26.69,2.07,5.5,3.79,6.19,49.33,15,49.33,15",
    fill: "#45e1c2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M398.87,406.93s-2.07,10.32,2.75,18.92",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M403.68,420.35s-2.06.69,3.45,9.63",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M191.65,353.16s-22.68,27-29.49,32.4a103.73,103.73,0,0,1-12.94,8.85l-24.51,24.52s.68,3.4-6.12,7.49-20.43,8.85-23.83,10.21S53.9,455,53.9,455Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M224.55,311.91c-2.38.72-11,.24-11,.24s-5.24-4-7.86-6.44-9.3-16.45-12.64-17.17-17.41,7.4-17.41,7.4-11.44-5-14.3-4.53-12.17,8.82-12.17,8.82-12.87-1.91-15.26,1.91-6.2,16-10,23.6-17.65,27.9-17.65,27.9l-1.9,2.62s2.86,1,11.68,5.49,22.89,26,22.89,26,19.55-9.06,30.52-14.07,19.79-16,22.18-20.51,6.44-8.82,11.44-12.87,14.31-5.73,16.46-8.59-1.44-7.15-1.44-7.15a34.73,34.73,0,0,0,3.82-2.39c1.19-1,6-3.57,6.44-6.43S226.94,311.2,224.55,311.91ZM187.83,334.8,192.36,321c1.91,1.43,10.26,4.53,10.26,4.53C197.13,326.93,187.83,334.8,187.83,334.8Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M140.14,316s-.71-4.06-.23-5.49,9.29-10.25,9.29-10.25",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "147.77 320.73 149.68 314.54 175.67 295.94",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M160.65,325.26s.95-6,2.15-6.91,10.25-3.1,10.25-3.1,13.83-11.92,16.21-11.92,19.79,9.3,24.32,8.82",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M221.21,313.1s-3.1,0-1.43,1.92,5.24,1,6.91.48",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M202.62,325.5s8.58-5,15.49-.95",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M216,326l-4.77,1.67a32.23,32.23,0,0,1,2.15,5.24l.23,1.44",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 187.83,
    y1: 334.8,
    x2: 183.54,
    y2: 344.34,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.57,371.76s15-9.77,20.51-13.83,8.34-3.34,11.2-4.29S123.45,357,133,368.9s8.58,20.74,7.39,23.13-31.23,20.51-31.23,20.51-4.3-17.17-16.93-27.43S74.57,371.76,74.57,371.76Z",
    fill: "#45e1c2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.48,400.29s27.83-17,32.47-19.8,10-6.6,10-6.6,1.46-7.36,8.54-7.61,13.92,2.54,23.19,7.61,20.75,23.61,22,31,3.66,9.64,1.71,14.46-9.28,5.08-10.74,5.08-4.88,3.05-4.88,3.05l-52.24,34",
    fill: "#45e1c2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.83,411.48s2.18,1.62-2.18,8.43",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M97.71,414.72s-.31,7.14-6.86,13.62",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSvg3);
export default __webpack_public_path__ + "static/media/BackSVG3.b189739e17bd965566d4ab5cfddcd12a.svg";
export { ForwardRef as ReactComponent };